import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox.js';
import ru from '@fancyapps/ui/src/Fancybox/l10n/ru';

function init() {
    if (document.querySelector('[data-fancybox]')) {
        Fancybox.bind('[data-fancybox]', {
            autoFocus: false,
            trapFocus: false,
            placeFocusBack: false,
            closeButton: 'inside',
            l10n: ru,
            template: {
                closeButton: ``,
            },
        });
    }
}

export default { init };
